import { __assign } from "tslib";
import { DocQueryParams } from '@office-start/common-types';
export function getOfficeRouteParamsFromDriveItem(driveId, itemId, docUrl, additionalParams) {
    var _a;
    if (additionalParams === void 0) { additionalParams = {}; }
    return __assign(__assign({}, additionalParams), (_a = {}, _a[DocQueryParams.DriveId] = driveId, _a[DocQueryParams.ItemId] = itemId, _a[DocQueryParams.DocUrl] = docUrl, _a));
}
//# sourceMappingURL=getOfficeRouteParamsFromDriveItem.js.map